import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FranchiseService } from './franchise.service';
import { Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { HeaderService } from '../header/header.service';
import { Offcanvas } from '../form.offcanvas';
import { ScriptLoader } from '../script-loader';
import { GroupService } from "../groups/groups.service";
import { AppSettings } from "../../config/config";

declare var $: any;
declare var jquery: any;
declare var d3: any;
declare var Chart: any;

@Component({
    selector: 'app-franchise',
    templateUrl: './franchise.component.html',
    styleUrls: [
        './../../assets/css/theme-default/bootstrap.css',
        './../../assets/css/theme-default/materialadmin.css',
        './../../assets/css/theme-default/font-awesome.min.css',
        './../../assets/css/theme-default/material-design-iconic-font.min.css',
        /* './../../assets/css/theme-default/libs/toastr/toastr.css?1425466569',*/
        './../../assets/css/theme-default/libs/DataTables/jquery.dataTables.css',
        './../../assets/css/theme-default/libs/bootstrap-datepicker/datepicker3.css',
        './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.colVis.css',
        './../../assets/css/theme-default/libs/DataTables/extensions/dataTables.tableTools.css',
        './../../_crop/css/style.css',
        './../../_crop/css/style-example.css',
        './franchise.component.css'],
    encapsulation: ViewEncapsulation.None,
    providers: [FranchiseService, LoginService, HeaderService, Offcanvas, ScriptLoader, GroupService]
})

export class FranchiseComponent implements OnInit {

    constructor(private FranchiseService: FranchiseService, private router: Router,
        private loginservice: LoginService, private headerservice: HeaderService,
        private offcanvas: Offcanvas,
        private scriptLoader: ScriptLoader, private groupservice: GroupService) {
    }


    public static gAcademicId = 0;

    getAuthToken: string;
    getSchoolId: any;

    academicYearList = [];

    endDateDatePicker = new Date();
    preLoader = true;
    schoolCurrency = 'INR';
    public schoolMatrices;
    totalSchool;
    totalActiveSchool;
    totalInactiveSchool;
    totalStudent;
    totalRegStudents = 0;
    lengthRegStudentsArray = 0;
    regAverage = 0;

    studentRegistration = [[0, 0]];
    regTickValue = [[0, '']];

    activeStaffAppUser = 0;
    inActiveStaffAppUser = 0;
    activeParentAppUser = 0;
    inActiveParentAppUser = 0;

    recentBroadcast = [];
    isApproved = false;


    // new one
    admissionByStatus = true;
    paymentHistoryByStatus = true;

    getNewAdmissionListArray = [];
    getDateAdmission = 0;

    noresultadmission = true;
    loaderadmission = true;


    getSchoolStatusListArray = [];
    getschoolStatusDate;
    loaderactivity = true;

    todayDate;
    viewActivityTotalStudent;
    viewActivityAttendence;
    viewActivityFeesCollected = 0;
    viewActivityDiaries;
    viewActivityTeacher1;
    viewActivityTeacher2;
    viewActivityTeacher3;

    getgetClassFeedListArray = [];
    feedCount = false;

    parentAppAndroidVersion;
    staffAppAndroidVersion;
    onlineFeeCollection = [];
    onlineFeeCollectionTable = null;

    getSchoolName;
    registeredName;
    getSchoolImage;
    getSchoolState;
    getSchoolLocality;
    accountType;
    onlinePaymentHistory = 'DISABLED';
    permissions: any;
    dataTablesInstances = {};
    schoolActivityDataInCall = false;
    loginMode = '';

    viewActivityClassNumber = '';
    viewActivityClassSection = '';
    chart;

    schoolLebel = [];
    schoolDataset = [];
    feesLebel = [];
    feesDataset = [];
    studentLebel = [];
    studentDataset = [];
    year = '2020-2030'; //for school graff
    academicYear; //for fees and student graff
    schoolChart;
    feesChart;
    studentChart;
    adminType: any
    feesModuleSettingsDetails: any
    isFranchise: any;
    fkFranchiseId: any;
    adminPermissionlist: any
    // get school info
    getSchoolInfoFromHeader() {
        this.headerservice.schoolInfo(this.getSchoolId, this.getAuthToken)
            .subscribe(
                (data: any) => {
                    this.getSchoolName = data.schoolName;
                    this.getSchoolImage = data.schoolImage;
                    this.getSchoolState = data.state;
                    this.getSchoolLocality = data.locality;
                    this.accountType = data.accountType;
                    this.registeredName = data.RegisteredPersonName.split(' ')[0];
                },
                error => {

                }
            );
    }

    //fetch dashboard matrix data
    getDashboardData() {
        this.FranchiseService.fetchDashboardData(this.getSchoolId, FranchiseComponent.gAcademicId, this.getAuthToken)
            .subscribe(
                (data: any) => {
                    // init script
                    this.initScripts();
                    setTimeout(() => this.initScripts(), 500);

                    // matrices data
                    this.totalSchool = data.totalSchool;
                    this.totalActiveSchool = data.totalActiveSchool;
                    this.totalInactiveSchool = data.totalInactiveSchool;
                    this.totalStudent = data.totalStudent;
                },
                error =>
                    () => {
                    }
            );
    }

    // token auth
    isStaffLoginValidToken() {
        let isValidToken = false;
        let isValidSchool = 0;
        this.loginservice.isValidToken(this.getAuthToken)
            .subscribe(
                (data: any) => {
                    isValidToken = data.isValid;
                    if (data.errorcode === 10010) {
                        this.router.navigate(['/suspended']);
                    } else if (isValidToken === true) {

                        this.loginservice.isValidSchoolId(this.getSchoolId)
                            .subscribe(
                                (validData: any) => {
                                    isValidSchool = validData.schoolExist;
                                    if (isValidSchool !== 1) {
                                        this.router.navigate(['/login']);
                                    }
                                    else {
                                        if (this.loginMode === 'STAFF') {
                                            this.router.navigate(['/exams']);
                                        }
                                        else {
                                            this.getDashboardData();
                                            this.getSchoolInfoFromHeader();
                                            //this.getNewAdmissionList();
                                            //this.getGroupsClassCategories(this.getSchoolId);
                                            //this.initDataTableServerProcess("new-admission-table-2", this.getSchoolId, this.getAuthToken, null, null, null, null)
                                        }
                                    }
                                },
                                error => {
                                }
                            );
                    } else {
                        this.router.navigate(['/login']);
                    }
                },
                error => {
                }
            );
    }

    isValidToken() {
        if (this.getAuthToken) {
            localStorage.setItem('usertoken', this.getAuthToken);
            localStorage.setItem('schoolinfo', this.getSchoolId);
            localStorage.setItem('loginMode', this.loginMode);
            localStorage.setItem('adminType', this.adminType);
            localStorage.setItem('feesModuleSettings', this.feesModuleSettingsDetails);
            localStorage.setItem('currency', this.schoolCurrency);
            localStorage.setItem('isFranchise', this.isFranchise);
            localStorage.setItem('fkFranchiseId', this.fkFranchiseId);
            localStorage.setItem('adminPermissionlist', this.adminPermissionlist);
            this.getDashboardData();
            this.getSchoolInfoFromHeader();
        } else {
            this.router.navigate(['/login']);
        }
    }

    initScripts() {
        this.scriptLoader.loadScript($, 'DASHBOARD');
    }

    academisYears() {
        this.academicYearList = [];
        this.FranchiseService.academicYears(this.getAuthToken).subscribe(
            (data: any) => {
                for (let i = 0; i < data.length; i++) {
                    this.academicYearList.push(data[i]);
                }
                this.currentAcademic();
            },
            error => {

            }
        );
    }

    currentAcademic() {
        for (let i = 0; i < this.academicYearList.length; i++) {
            if (this.academicYearList[i].blocked == 0) {
                this.academicYear = this.academicYearList[i].year;
                console.log("current academic", this.academicYear)
                this.studentGraffDataFetch();
                this.feesGraffDataFetch();
            }
        }
    }

    schoolYearChange(range) {
        this.schoolChart.destroy();
        this.year = range;
        this.schoolGraffDataFetch();
    }

    feesYearChange(range) {
        this.feesChart.destroy();
        this.academicYear = range;
        this.feesGraffDataFetch();
    }

    studentYearChange(range) {
        this.studentChart.destroy();
        this.academicYear = range;
        this.studentGraffDataFetch();
    }

    schoolGraffDataFetch() {
        this.schoolLebel = [];
        this.schoolDataset = [];
        this.FranchiseService.schoolGraffInfo(this.year, this.getAuthToken).subscribe(
            (data: any) => {
                for (let i = 0; i < data.length; i++) {
                    this.schoolLebel.push(data[i].year);
                    this.schoolDataset.push(data[i].totalSchool);
                }
                this.schoolGraff();
            },
            error => {

            }
        );
    }

    feesGraffDataFetch() {
        this.feesLebel = [];
        this.feesDataset = [];
        this.FranchiseService.feesGraffInfo(this.academicYear, this.getAuthToken).subscribe(
            (data: any) => {
                for (let i = 0; i < data.length; i++) {
                    this.feesLebel.push(data[i].schoolName.split(" ")[0]);
                    this.feesDataset.push(data[i].totalCollectedFees);
                }
                this.feesGraff();
            },
            error => {

            }
        );
    }

    studentGraffDataFetch() {
        this.studentLebel = [];
        this.studentDataset = [];
        this.FranchiseService.studentGraffInfo(this.academicYear, this.getAuthToken).subscribe(
            (data: any) => {
                for (let i = 0; i < data.length; i++) {
                    this.studentLebel.push(data[i].schoolName.split(" ")[0]);
                    this.studentDataset.push(data[i].totalStudent);
                }
                this.studentGraff();
            },
            error => {

            }
        );
    }

    schoolGraff() {

        this.schoolChart = new Chart("schoolGraff", {
            type: 'line',
            data: {
                labels: this.schoolLebel,
                datasets: [{
                    label: 'SCHOOLS',
                    data: this.schoolDataset,
                    fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    backgroundColor: '#3C89F5',
                    color: '#3C89F5',
                    tension: 0.1
                }]
            },
            options: {
                scales: {
                    y: {
                        ticks: {
                            stepSize: 1
                        }
                    }
                }
            }
        });
    }

    feesGraff() {
        this.feesChart = new Chart("feesGraff", {
            type: 'bar',
            data: {
                labels: this.feesLebel,
                datasets: [{
                    label: 'FEES',
                    data: this.feesDataset,
                    fill: true,
                    borderColor: 'rgb(75, 192, 192)',
                    borderRadius: 50,
                    borderSkipped: false,
                    backgroundColor: '#3C89F5',
                    tension: 0.1
                }]
            },
            options: {
                scales: {
                    y: {
                        ticks: {
                            callback: (val) => {
                                if (!val) return 0;
                                const units = ['', 'K', 'M', 'B'];
                                const k = 1000;
                                const magnitude = Math.floor(Math.log(val) / Math.log(k));

                                return (
                                    '₹' + val / Math.pow(k, magnitude) + units[magnitude > 0 ? magnitude : 0]
                                );
                            }
                        }
                    }
                }
            }

        });
    }

    studentGraff() {
        this.studentChart = new Chart("studentGraff", {
            type: 'bar',
            data: {
                labels: this.studentLebel,
                datasets: [{
                    label: 'STUDENTS',
                    data: this.studentDataset,
                    fill: false,
                    borderColor: 'rgb(75, 192, 192)',
                    borderRadius: 50,
                    borderSkipped: false,
                    backgroundColor: '#009F06',
                    tension: 0.1
                }]
            },
            options: {
                scales: {
                    y: {
                        ticks: {
                            //mirror: true,
                            //autoSkipPadding: 10,
                            //display: false,
                            //autoSkip: false,
                            //align: 'start',
                            // maxRotation: 90,
                            // minRotation: 90,
                            // padding: -150
                            //autoSkip: true,
                            //minTicksLimit: 7,

                            callback: (val) => {
                                if (!val) return 0;
                                const units = ['', 'K', 'M', 'B'];
                                const k = 1000;
                                const magnitude = Math.floor(Math.log(val) / Math.log(k));
                                return (
                                    val / Math.pow(k, magnitude) + units[magnitude > 0 ? magnitude : 0]
                                );
                            }
                        }
                    }
                }
            }

        });
    }

    ngOnInit() {
        const tokenCookie = document.cookie.split(';').find(cookie => cookie.trim().startsWith('usertoken='));
        let tokenValue = tokenCookie ? tokenCookie.split('=')[1] : null;
        this.getAuthToken = tokenValue;
        const getSchoolIdDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('schoolinfo='));
        let getSchoolIdDetailsValue = getSchoolIdDetails ? getSchoolIdDetails.split('=')[1] : null;
        this.getSchoolId = getSchoolIdDetailsValue
        const loginModeDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('loginMode='));
        let loginModeDetailsValue = loginModeDetails ? loginModeDetails.split('=')[1] : null;
        this.loginMode = loginModeDetailsValue;
        const adminTypeDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('adminType='));
        let adminTypeDetailsValue = adminTypeDetails ? adminTypeDetails.split('=')[1] : null;
        this.adminType = adminTypeDetailsValue;
        const schoolCurrencyDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('currency=')) || 'INR';
        let schoolCurrencyDetailsValue = schoolCurrencyDetails ? schoolCurrencyDetails.split('=')[1] : null;
        this.schoolCurrency = schoolCurrencyDetailsValue;
        const isFranchiseDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('isFranchise='));
        let isFranchiseValue = isFranchiseDetails ? isFranchiseDetails.split('=')[1] : null;
        this.isFranchise = isFranchiseValue;
        const fkFranchiseIdDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('fkFranchiseId='));
        let fkFranchiseIdValue = fkFranchiseIdDetails ? fkFranchiseIdDetails.split('=')[1] : null;
        this.fkFranchiseId = fkFranchiseIdValue;

        if (this.loginMode === 'STAFF') {
            this.router.navigate(['/exams']);
        }
        const adminPermissionlistDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('adminPermissionlist='));
        const adminPermissionlist = adminPermissionlistDetails ? adminPermissionlistDetails.split('=')[1] : null;
        this.adminPermissionlist = adminPermissionlist

        if (adminPermissionlist) {
            const list = JSON.parse(adminPermissionlist);
            this.permissions = list;
        }
        let feesModuleSettings = [{ isFeesModuleEnable: '', SettingName: '' }];
        const feesModuleSettingsStoreDetails = document.cookie.split(';').find(cookie => cookie.trim().startsWith('feesModuleSettings='));
        const feesModuleSettingsStore = feesModuleSettingsStoreDetails ? feesModuleSettingsStoreDetails.split('=')[1] : null;
        this.feesModuleSettingsDetails = feesModuleSettingsStore;
        if (feesModuleSettingsStore) {
            feesModuleSettings = JSON.parse(feesModuleSettingsStore);
            if (feesModuleSettings.length > 0) {
                let isOnlinePayEnabled = false;
                let isIndependentFeeEnabled = false;
                for (const setting of feesModuleSettings) {
                    if (setting.isFeesModuleEnable === 'ENABLED' && setting.SettingName === 'ONLINE_PAYMENT_INDEPENDENT_TO_FEES_STRUCTURE') {
                        isIndependentFeeEnabled = true;
                    }
                    if (setting.isFeesModuleEnable === 'ENABLED' && setting.SettingName === 'MOBILE_FEES_PAYMENT') {
                        isOnlinePayEnabled = true;
                    }
                }
                if (isIndependentFeeEnabled && isOnlinePayEnabled) {
                    this.onlinePaymentHistory = 'ENABLED';
                } else {
                    this.onlinePaymentHistory = 'DISABLED';
                }
            }
        }
        const h = this;

        this.isValidToken();

        this.academisYears();

        this.schoolGraffDataFetch();
        //this.feesGraffDataFetch();
        //this.studentGraffDataFetch();

        setTimeout(() => this.initScripts(), 500);
    }

    schoolCategories = [];
    selectedCategory = null;
    selectedSection = null;
    schoolClasses = [];
    selectClassStatus = true;
    schoolClassesSections = [];
    selectClassSectionStatus = true;
    selectedClass = null;
    studentListTable: any;

}
